import { Component, OnInit } from '@angular/core';
import { ThemesService } from 'src/app/services/commonService/themes.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { LoginService } from 'src/app/services/dataLayer/login.service';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { ImageLinkListComponent } from '../image-link-list/image-link-list.component';
import { Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';

@Component({
  selector: 'app-saudiabusiness-landing',
  templateUrl: './saudiabusiness-landing.component.html',
  styleUrls: ['./saudiabusiness-landing.component.scss'],
  imports: [ImageLinkListComponent, RouterLink, MatButton, MatIcon, MatDivider, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle]
})
export class SaudiabusinessLandingComponent implements OnInit {
  constructor(
    private _ThemeService: ThemesService,
    private _DataLayerService: DataLayerService,
    public _ciamService: CiamService,
    private router: Router
  ) { }

  ngOnInit(): void {
    sessionStorage.clear()
    this._ThemeService.clearThemes();
    this._DataLayerService.registrationPageLanding('Corporate Landing Page');
  }
  registerNow() {
    this._DataLayerService.registration_form();
  }
  goToLanding(): void {
    this.router.navigate(['/login-landing']);
  }
  view_all_faq() { }
}
